(function () {
  'use strict';

  var picker = document.querySelector('[data-cc-name-birthstone-picker]');
  if (!picker) return;

  // primary field per row: 'name' (built) | 'initial' (reserved). The row's
  // primary input is produced by buildPrimary(); an 'initial' branch can be added
  // there later without touching the count/stone/gate machinery below.
  var primary = picker.dataset.primary || 'name';

  var required = picker.hasAttribute('data-required');
  var pickerLabel = picker.dataset.label || 'Names';
  var namePrefix = picker.dataset.namePrefix || 'Name';
  var nameMaxChars = parseInt(picker.dataset.nameMaxChars, 10) || 12;
  var charset = picker.dataset.charset || 'any';
  var comboProp = picker.dataset.comboProperty || 'Names & Birthstones';

  var countSelector = picker.querySelector('[data-cc-count-selector]');
  var slotsContainer = picker.querySelector('[data-cc-slots]');
  var panel = picker.querySelector('[data-cc-stone-panel]');
  var removeBtn = picker.querySelector('[data-cc-remove-btn]');
  var gateMsg = picker.querySelector('[data-cc-nbs-gatemsg]');
  var comboInput = picker.querySelector('[data-cc-combo-input]');
  var namesInput = picker.querySelector('[data-cc-names-input]');
  var stonesInput = picker.querySelector('[data-cc-stones-input]');

  // count = chosen N (0 = none picked yet). rows = fixed array of length count,
  // each { name: '', stone: null | { month, abbrev, stone } }. activeRow = the row
  // the stone grid fills; always a valid index while count > 0, null when count 0.
  //
  // gridOpen: the stone grid shows while any row still needs a stone and auto-
  // CLOSES once every row has one (the name text boxes stay inline regardless).
  // Picking auto-advances to the next stone-less row (grid stays); when none
  // remain it closes. Tapping any row's chip reopens the grid with that row
  // active, so a chosen stone can be edited. No outside-click dismiss.
  var count = 0;
  var rows = [];
  var activeRow = null;
  var gridOpen = false;

  // --- Order-data contract (LOCKED) ---
  // properties[<comboProp>] = "<name> with <stone>, ..." in row order (source of truth).
  // properties[_Names] / properties[_Birthstones] = space-joined parallels (Mal export).
  // cc:name-birthstone-changed carries { property, count, selectedCount, filled, min,
  //   required, label }. count/filled stay 0 until EVERY row has both a name and a
  //   stone (all-N-required), so the switcher gates ATC until fully paired.

  function filterName(v) {
    var out = v.replace(/\s+/g, ''); // one name per box; hyphens for compound names
    if (charset === 'letters_only') out = out.replace(/[^A-Za-z\-]/g, '');
    else if (charset === 'alphanumeric') out = out.replace(/[^A-Za-z0-9\-]/g, '');
    return out.slice(0, nameMaxChars);
  }

  function findCell(month) {
    return panel.querySelector('[data-cc-stone][data-month="' + month + '"]');
  }

  function nextRowMissingStone() {
    for (var i = 0; i < count; i++) { if (!rows[i].stone) return i; }
    return -1;
  }

  function isComplete() {
    return count > 0 && rows.every(function (r) {
      return r.name.trim() !== '' && r.stone;
    });
  }

  function emit() {
    var complete = isComplete();

    // Pairs, in row order, including only rows that hold BOTH a name and a stone.
    // At completion (gate satisfied) that is every row, in order.
    var pairs = [];
    var names = [];
    var stones = [];
    rows.forEach(function (r) {
      var nm = r.name.trim();
      if (nm !== '' && r.stone) pairs.push(nm + ' with ' + r.stone.stone);
      if (nm !== '') names.push(nm);
      if (r.stone) stones.push(r.stone.stone);
    });
    comboInput.value = pairs.join(', ');
    namesInput.value = names.join(' ');
    stonesInput.value = stones.join(' ');

    // Blank output posts no key at all. Re-applied on every emit, which is the
    // "on init AND on every input event" half of the ccSubmitWhenFilled contract.
    window.ccSubmitWhenFilled(comboInput);
    window.ccSubmitWhenFilled(namesInput);
    window.ccSubmitWhenFilled(stonesInput);

    document.dispatchEvent(new CustomEvent('cc:name-birthstone-changed', {
      detail: {
        property: comboProp,
        count: complete ? count : 0,
        selectedCount: count,
        filled: complete ? count : 0,
        min: 1,
        required: required,
        label: pickerLabel
      }
    }));
  }

  function renderCountSelector() {
    if (!countSelector) return;
    countSelector.querySelectorAll('[data-cc-count]').forEach(function (btn) {
      var isOn = parseInt(btn.dataset.ccCount, 10) === count;
      btn.classList.toggle('is-selected', isOn);
      btn.setAttribute('aria-pressed', isOn ? 'true' : 'false');
    });
  }

  // Builds the row's primary field (name text box). Kept isolated so a future
  // 'initial' primary can swap in an A-Z chip without touching row/stone wiring.
  function buildPrimary(index) {
    var input = document.createElement('input');
    input.type = 'text';
    input.className = 'cc-text-engraving__input cc-name-birthstone-picker__name';
    input.placeholder = namePrefix + ' ' + (index + 1);
    input.setAttribute('aria-label', namePrefix + ' ' + (index + 1));
    input.maxLength = nameMaxChars;
    input.autocomplete = 'off';
    // Pure-UI box: the row values are posted through the hidden outputs in
    // emit(), never by these inputs. A nameless control inside the product form
    // is what breaks a cached [name^="properties"] serialiser the moment it is
    // re-queried, so give it an inert name + the void form owner instead of
    // leaving it nameless. Mirrors cc-engraving-slot-N in cc-text-engraving.js.
    window.ccNeverSubmit(input, 'cc-nbs-name-' + (index + 1));
    input.value = rows[index].name;
    if (required) input.setAttribute('aria-required', 'true');
    input.addEventListener('input', function () {
      var filtered = filterName(this.value);
      if (filtered !== this.value) this.value = filtered;
      rows[index].name = this.value;
      // Typing must not re-render (would drop focus); just re-sync outputs + UI.
      syncGate();
      emit();
    });
    return input;
  }

  function buildStoneChip(index) {
    var entry = rows[index].stone;
    var chip = document.createElement('button');
    chip.type = 'button';
    chip.className = 'cc-name-birthstone-picker__chip' +
      (entry ? ' is-filled' : '') +
      (activeRow === index ? ' is-editing' : '');

    if (entry) {
      var cell = findCell(entry.month);
      var cellImg = cell ? cell.querySelector('img') : null;
      if (cellImg) {
        var img = cellImg.cloneNode(true);
        img.className = 'cc-name-birthstone-picker__chip-img';
        img.removeAttribute('loading');
        chip.appendChild(img);
      }
      var lbl = document.createElement('span');
      lbl.className = 'cc-name-birthstone-picker__chip-label';
      lbl.textContent = entry.abbrev;
      chip.appendChild(lbl);
      chip.setAttribute('aria-label', 'Birthstone ' + entry.stone + '. Tap to change.');
    } else {
      chip.textContent = 'Birthstone';
      chip.setAttribute('aria-label', 'Choose a birthstone for ' + namePrefix.toLowerCase() + ' ' + (index + 1));
    }

    (function (idx) {
      chip.addEventListener('click', function (e) { e.stopPropagation(); setActiveRow(idx); });
    })(index);
    return chip;
  }

  function renderSlots() {
    slotsContainer.innerHTML = '';
    for (var i = 0; i < count; i++) {
      var row = document.createElement('div');
      row.className = 'cc-name-birthstone-picker__row' + (activeRow === i ? ' is-active' : '');
      row.appendChild(buildPrimary(i));
      row.appendChild(buildStoneChip(i));
      slotsContainer.appendChild(row);
    }
  }

  function syncGate() {
    if (!gateMsg) return;
    if (count > 0 && !isComplete()) {
      var noun = count === 1 ? pickerLabel.toLowerCase() : pickerLabel.toLowerCase();
      gateMsg.hidden = false;
      gateMsg.textContent = count === 1
        ? 'Enter the ' + namePrefix.toLowerCase() + ' and birthstone to continue.'
        : 'Enter all ' + count + ' ' + noun.replace(/s?$/, 's') + ' and their birthstones to continue.';
    } else {
      gateMsg.hidden = true;
    }
  }

  function render() {
    renderCountSelector();
    renderSlots();

    // Grid shows while a row still needs a stone (gridOpen), closes when all filled.
    panel.hidden = !gridOpen;
    removeBtn.hidden = activeRow === null || !rows[activeRow] || !rows[activeRow].stone;

    // Highlight the panel cell matching the active row's stone.
    panel.querySelectorAll('[data-cc-stone]').forEach(function (cell) {
      var isSel = activeRow !== null && rows[activeRow] && rows[activeRow].stone
        && rows[activeRow].stone.month === cell.dataset.month;
      cell.classList.toggle('is-selected', isSel);
    });

    syncGate();
    emit();
  }

  function setCount(n) {
    if (n === count) return;
    if (n < count) {
      rows = rows.slice(0, n);
    } else {
      while (rows.length < n) rows.push({ name: '', stone: null });
    }
    count = n;
    // Point at the first row needing a stone and open the grid; if every row
    // already has one, close it. Null/closed at count 0.
    if (count === 0) {
      activeRow = null;
      gridOpen = false;
    } else {
      var e = nextRowMissingStone();
      if (e === -1) { activeRow = 0; gridOpen = false; }
      else { activeRow = e; gridOpen = true; }
    }
    render();
  }

  // Re-point which row the stone grid fills AND (re)open it — used when the
  // shopper taps a chip to edit it, including a filled chip once complete.
  function setActiveRow(index) {
    activeRow = index;
    gridOpen = true;
    render();
    panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  if (countSelector) {
    countSelector.querySelectorAll('[data-cc-count]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        setCount(parseInt(this.dataset.ccCount, 10));
      });
    });
  }

  panel.querySelectorAll('[data-cc-stone]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (activeRow === null) return;
      var wasEditing = !!(rows[activeRow] && rows[activeRow].stone);
      rows[activeRow].stone = {
        month: this.dataset.month,
        abbrev: this.dataset.abbrev,
        stone: this.dataset.stone
      };
      // Filling forward vs editing. Advancing is only ever right when this pick
      // FILLED an empty row: then move to the next empty one and keep the
      // panel open so a run of picks needs no taps in between. If the shopper
      // deliberately reopened an already-filled row to change it, jumping
      // them somewhere else afterwards is worse than doing nothing - so close
      // the panel and leave them where they were. Either way the panel closes
      // once nothing is left empty.
      if (wasEditing) {
        gridOpen = false;
      } else {
        var e = nextRowMissingStone();
        if (e !== -1) { activeRow = e; }
        else { gridOpen = false; }
      }
      render();
    });
  });

  removeBtn.addEventListener('click', function () {
    // Clears the active row's stone, keeps it active and reopens the grid.
    if (activeRow !== null && rows[activeRow] && rows[activeRow].stone) {
      rows[activeRow].stone = null;
      gridOpen = true;
      render();
    }
  });

  // Single-count mode (only one count offered): skip the selector, draw the rows.
  var initCount = parseInt(picker.dataset.ccInitCount, 10);
  if (initCount > 0) {
    count = initCount;
    rows = [];
    while (rows.length < count) rows.push({ name: '', stone: null });
    activeRow = 0;
    gridOpen = true;
  }
  render();
})();
